import { render, staticRenderFns } from "./AcknowledgedHrDocumentsList.vue?vue&type=template&id=495140ab&scoped=true&"
import script from "./AcknowledgedHrDocumentsList.vue?vue&type=script&lang=js&"
export * from "./AcknowledgedHrDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgedHrDocumentsList.vue?vue&type=style&index=0&id=495140ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495140ab",
  null
  
)

export default component.exports